// extracted by mini-css-extract-plugin
export default {"form":"Ig8xuz","button":"yJ7r8w"};